"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_circular_progressbar_1 = require("react-circular-progressbar");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var ProgressBar = function (_a) {
    var currentValue = _a.currentValue, maxValue = _a.maxValue, currentValueText = _a.currentValueText, maxValueText = _a.maxValueText;
    var progressPercents = (0, react_1.useMemo)(function () { return (currentValue * 100) / maxValue; }, [maxValue, currentValue]);
    var calculateCurrentPositionRotation = (0, react_1.useCallback)(function (percent) {
        var start = 0;
        var end = 0.5;
        return (start + (end - start) * (percent / 100) + (percent === 0 ? 0.74 : 0.75));
    }, []);
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement(react_circular_progressbar_1.CircularProgressbar, { value: progressPercents, strokeWidth: 6, circleRatio: 0.5, styles: (0, react_circular_progressbar_1.buildStyles)({
                rotation: 0.75,
                strokeLinecap: 'round',
                textSize: '16px',
                pathTransitionDuration: 0.5,
                pathColor: "#F79622",
                trailColor: '#afb7c6',
            }) }),
        react_1.default.createElement(react_circular_progressbar_1.CircularProgressbar, { value: 100, strokeWidth: 15, circleRatio: 0.01, styles: (0, react_circular_progressbar_1.buildStyles)({
                rotation: calculateCurrentPositionRotation(progressPercents),
                strokeLinecap: 'butt',
                pathTransitionDuration: 0.5,
                pathColor: "#FFF",
                trailColor: 'transparent',
            }) }),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.textContainer },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.currentAmount }, currentValueText),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.maxAmount }, maxValueText))));
};
exports.default = ProgressBar;
